export default __webpack_public_path__ + "static/media/1874.fac01e29.png";